// The compose draft's per-tab mirror — §3.2a "the draft rides across the
// OAuth round trip". `root.mailComposeDraft` is memory: a same-tab OAuth
// redirect (the popup-blocked fallback) and a plain reload both empty it.
// This mirror is the recovery copy, per WORKSPACE per TAB, exactly the
// shared/functions/minimizedSlots.js discipline: sessionStorage (never
// localStorage — a draft is tab-scoped work in progress, not a preference),
// defensive on every read, a `wsId` stamp checked back as the tenant
// backstop, and helpers INLINED in each export (frank.toJSON drops
// module-local helpers — FA204).
//
// NOT re-exported from the function barrels on purpose: these are internal
// primitives of functions/compose.js, not `el.call` targets — the same
// reasoning as ./sameWorkspaceWriter.js.

export const readParkedMailDraft = (wsId, storage) => {
  const store = storage || (typeof sessionStorage === 'undefined' ? null : sessionStorage)
  if (!store) return null
  try {
    const raw = store.getItem('mailComposeDraft.' + String(wsId || 'default'))
    if (!raw) return null
    const parsed = JSON.parse(raw)
    if (!parsed || typeof parsed !== 'object') return null
    if (String(parsed.wsId || '') !== String(wsId || '')) return null
    const draft = parsed.draft
    return draft && typeof draft === 'object' ? draft : null
  } catch (e) {
    return null
  }
}

export const writeParkedMailDraft = (wsId, draft, storage) => {
  const store = storage || (typeof sessionStorage === 'undefined' ? null : sessionStorage)
  if (!store) return
  const key = 'mailComposeDraft.' + String(wsId || 'default')
  try {
    if (!draft) {
      store.removeItem(key)
      return
    }
    // Attachments carry server-minted storagePaths only — a File/Blob never
    // reaches this shape, so the slot always JSON-serialises.
    store.setItem(key, JSON.stringify({ wsId: String(wsId || ''), draft }))
  } catch (e) {
    // Quota or privacy mode — the in-memory slot still works; the mirror is
    // best-effort by design.
  }
}
